import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import numeral from 'numeral';
import Highcharts from 'highcharts';
import HighchartsGantt from 'highcharts/modules/gantt';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import HighchartsReact from 'highcharts-react-official';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// Components
// import GroupCard from '../../components/GroupCard';

// Actions
import { gameActions } from '../../actions';

import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';
// import infoModal from '../../assets/info-modal-1.png';

// Initialize Gantt module
HighchartsGantt(Highcharts);
NoDataToDisplay(Highcharts);

// Task colors for different activities
const taskColors = {
  'front-ratio': '#007bff',
  'back-ratio': '#28a745',
  'loan-to-value': '#ffc107',
  'risk-assessment': '#fd7e14',
  decision: '#dc3545',
};

// INLINE COMPONENTS
const TimelineChart = ({ data }) => {
  const chartOptions = {
    chart: {
      type: 'xrange',
      height: 600,
      backgroundColor: 'transparent',
    },
    credits: {
      enabled: false,
    },
    title: {
      text: 'First Loan Application Processing Timeline by Group',
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
      },
    },
    xAxis: {
      type: 'datetime',
      title: {
        text: 'Time',
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
        },
      },
      dateTimeLabelFormats: {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%e. %b',
        week: '%e. %b',
        month: "%b '%y",
        year: '%Y',
      },
    },
    yAxis: {
      categories: data.map((group) => group.groupName),
      title: {
        text: 'Groups',
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
        },
      },
      reversed: true, // Show first group at top
    },
    legend: {
      enabled: true,
      align: 'center',
      verticalAlign: 'bottom',
    },
    tooltip: {
      headerFormat: '<span style="font-size:12px">{point.key}</span><br/>',
      pointFormat:
        '<span style="color:{series.color}">{point.task}: </span>' +
        '<b>{point.duration:.2f}s</b><br/>' +
        '<span>Start: {point.startTime}</span><br/>' +
        '<span>End: {point.endTime}</span><br/>',
      formatter: function () {
        const startTime = new Date(this.x).toLocaleTimeString();
        const endTime = new Date(this.x2).toLocaleTimeString();
        const duration = (this.x2 - this.x) / 1000;

        return `<span style="font-size:12px">${
          data[this.y].groupName
        }</span><br/>
                <span style="color:${this.color}">${this.task}: </span>
                <b>${duration.toFixed(2)}s</b><br/>
                <span>Start: ${startTime}</span><br/>
                <span>End: ${endTime}</span><br/>
                <span>Application: ${this.applicationId}</span>`;
      },
    },
    plotOptions: {
      xrange: {
        borderRadius: 3,
        borderWidth: 0,
        grouping: false,
        dataLabels: {
          enabled: true,
          format: '{point.task}',
          style: {
            fontSize: '10px',
            fontWeight: 'bold',
            textOutline: '1px contrast',
          },
        },
      },
    },
    series: data.flatMap((group, groupIndex) =>
      group.tasks.map((task) => ({
        name: task.activity,
        data: [
          {
            x: task.startTime,
            x2: task.endTime,
            y: groupIndex,
            task: task.activity,
            applicationId: task.applicationId,
            duration: task.duration,
            color: taskColors[task.activity] || '#6c757d',
          },
        ],
        showInLegend: groupIndex === 0, // Only show legend for first group to avoid duplicates
      }))
    ),
    noData: {
      style: {
        fontSize: '16px',
        color: '#666',
      },
      position: {
        align: 'center',
        verticalAlign: 'middle',
      },
    },
  };

  return (
    <div className='timeline-chart'>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        containerProps={{ style: { height: '600px', width: '100%' } }}
      />
    </div>
  );
};

class DebriefTimeline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: this.props.item || null,
    };
  }

  componentDidMount() {
    const { dispatch, match, game } = this.props;
    if (match.params.id && !game?.data?._id) {
      dispatch(gameActions.fetchGames(match.params.id));
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      item: newProps.item,
    });
  }

  render() {
    const { game } = this.props;
    const gameData = game.data;

    // Tasks list in processing order
    const tasksNames = [
      'front-ratio',
      'back-ratio',
      'loan-to-value',
      'risk-assessment',
      'decision',
    ];

    // Calculate timeline data for each group
    const timelineData = [];

    gameData?.groups?.forEach((group, groupIndex) => {
      const groupIdentifier = group?.name || `Team ${groupIndex + 1}`;

      // Step 1: Get the first decision item for this group (first completed loan)
      const decisionItems =
        group?.items?.filter((item) => item.activity === 'decision') || [];

      if (decisionItems.length === 0) return; // Skip groups with no decisions

      // Sort by created_at to get the first completed loan
      decisionItems.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );
      const firstDecision = decisionItems[0];
      const firstLoanId = firstDecision.application;

      // Step 2: Get all tasks for this specific loan application
      const loanTasks =
        group?.items?.filter((item) => item.application === firstLoanId) || [];

      // Step 3: Process each task type and calculate timeline
      const groupTasks = [];

      tasksNames.forEach((taskName) => {
        const taskItems = loanTasks.filter(
          (item) => item.activity === taskName
        );

        if (taskItems.length > 0) {
          // Take the first occurrence of each task type
          taskItems.sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at)
          );
          const task = taskItems[0];

          let startTime, duration;

          // Calculate start time and duration
          if (task.created_at) {
            const createdAt = new Date(task.created_at).getTime();

            // Use elapsed_time if available, otherwise calculate from dates
            if (task.elapsed_time) {
              duration = task.elapsed_time; // Already in milliseconds
              startTime = createdAt - duration;
            } else if (task.started_at) {
              startTime = new Date(task.started_at).getTime();
              duration = createdAt - startTime;
            } else {
              // Fallback: assume task took 30 seconds and ended at created_at
              duration = 30000;
              startTime = createdAt - duration;
            }

            const endTime = startTime + duration;

            groupTasks.push({
              activity: taskName,
              startTime,
              endTime,
              duration: duration / 1000, // Convert to seconds for display
              applicationId: firstLoanId,
            });
          }
        }
      });

      // Only include groups that have task data
      if (groupTasks.length > 0) {
        timelineData.push({
          groupName: groupIdentifier,
          groupId: group._id,
          applicationId: firstLoanId,
          tasks: groupTasks,
        });
      }
    });

    // Sort by group name for consistent display
    timelineData.sort((a, b) => a.groupName.localeCompare(b.groupName));

    console.log({ timelineData });

    return (
      <div>
        <Header />

        <h2 className='mt-3 sec-title fs-3'>
          Processing Timeline{' '}
          <small className='float-end'>
            <DebriefMenu
              game_id={game.data._id}
              location={this.props.location}
            />
          </small>
        </h2>

        <div className='row mt-3'>
          <div className='col-12 mb-3'>
            <p className='text-center'>
              This timeline shows the processing sequence for each group's first
              completed loan application. Each colored bar represents a
              different task type, showing when it started and how long it took.
              Groups are listed vertically, with time flowing horizontally from
              left to right.
            </p>
          </div>

          {/* CHART */}
          <div className='col-12'>
            <div className='mb-4 pt-3 shadow bg-white border'>
              <TimelineChart data={timelineData} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { player, game } = state;
  return {
    game,
    player,
  };
}

export default connect(mapStateToProps)(DebriefTimeline);
